<ul class="pointer" (click)="hideMenu($event)">
	<li routerLinkActive="active" [hidden]="!hasPublication"><a [routerLink]="['/preferences']"><i class="fa fa-user"></i>{{ 'ACCOUNT_SETTINGS' | translate }}</a></li>
	<li routerLinkActive="active" [hidden]="!hasPublication" class="publication-desktop" [hasPermission]="'publicationconfig'">
		<a [routerLink]="['/publication/config']"><i class="fa fa-cog"></i>{{ 'PUBLICATION' | translate }}</a>
	</li>
	<li routerLinkActive="active" [hidden]="!!(hasPublication && !doublePublicationLink)" class="publication-desktop" [hasPermission]="'usermanagement'">
		<a [routerLink]="['/publication/users']"><i class="fa fa-users"></i>{{ 'USERS' | translate }}</a>
	</li>
	<li (click)="setOpenMenu('publication')" [hidden]="!hasPublication" class="publication-mobile" [ngClass]="{open: openMenu === 'publication', 'active': activeLink === 'publication'}">
		<a [hasPermission]="'publicationconfig'"><i class="fa fa-cog"></i>{{ 'PUBLICATION' | translate }}</a>
		<bb-publication-menu></bb-publication-menu>
	</li>
	<li (clickOutside)="hidePublicationsMenu()" [hidden]="!(hasPublication && userInfo && userInfo.publications)" [ngClass]="{'open': showPublications}">
		<a *ngIf="!globalLogin" (click)="switchPublication()"><i class="fa fa-database"></i>{{ 'SWITCH_PUBLICATION' | translate }} <small>{{ 'LOGIN_REQUIRED' | translate }}</small></a>
		<a *ngIf="globalLogin" (click)="showPublications = !showPublications" do-not-close-menu="true"><i class="fa fa-database"></i>{{ 'SWITCH_PUBLICATION' | translate }}</a>
		<div class="publication-arrow" [hidden]="!showPublications"></div>
		<div class="publication-switcher" [hidden]="!showPublications">
			<ul *ngIf="userInfo && showPublications">
				<li *ngFor="let publication of userInfo.publications">
					<a *ngIf="publication" (click)="switchPublication(publication)" [ngClass]="{'active': publicationId == publication.id}">{{ publication.label || publication.name || publication.vhost }}<i class="fa fa-check" *ngIf="publicationId == publication.id"></i></a>
				</li>
			</ul>
		</div>
	</li>
	<hr [hidden]="!hasPublication">
	<li routerLinkActive="active"><a (click)="hideUserMenu()" href="//support.bluebillywig.com" target="_blank"><i class="fa fa-question-circle"></i>{{ 'SUPPORT' | translate }}</a></li>
	<li routerLinkActive="active" [hidden]="!hasPublication"><a (click)="showAbout()"><i class="fa fa-building-o"></i>{{ 'ABOUT' | translate }}</a></li>
	<li routerLinkActive="active"><a href="#" [routerLink]="['/logout']" data-cy="logout-button"><i class="fa fa-sign-out"></i>{{ 'SIGN_OUT' | translate }}</a></li>

	<hr [hasPermission]="'root'">
	<li [hasPermission]="'root'" class="root">
		<bb-text [(ngModel)]="switchToUser" (keyup.enter)="switchUser()" placeholder="switch user"></bb-text>
	</li>
</ul>
